module.exports = __webpack_public_path__ + "img/hero.3ed813f7.png";